export enum NodeEnv {
	DEVELOPMENT = 'development',
	PRODUCTION = 'production',
}

export enum Env {
	DEVELOPMENT = 'development',
	STAGE = 'stage',
	TEST = 'test',
	PRODUCTION = 'production',
}
